import { SpriteFrame } from 'cc';

declare module 'cc' {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface SpriteFrame {
        /** 是否是低品質圖片 */
        isLowQuality: boolean;
        /** 低品質圖片縮放比例 */
        lowQualityResizeScale: number;
        _isLowQuality: boolean;
        _lowQualityResizeScale: number;
    }
}

Object.defineProperty(SpriteFrame.prototype, 'isLowQuality', {
    configurable: true,
    get(this: SpriteFrame) {
        return this._isLowQuality ?? false;
    },
    set(this: SpriteFrame, value: boolean) {
        if (this._isLowQuality === value) {
            return;
        }
        this._isLowQuality = value;
    },
});

Object.defineProperty(SpriteFrame.prototype, 'lowQualityResizeScale', {
    configurable: true,
    get(this: SpriteFrame) {
        return this._lowQualityResizeScale ?? 1;
    },
    set(this: SpriteFrame, value: number) {
        if (this._lowQualityResizeScale === value) {
            return;
        }
        this._lowQualityResizeScale = value;
    },
});
